<template>
  <div>
    <CarouselAgreementSelector :id="id"/>
    <FilesOfAgreement :id="id" :show-client-info="true"/>
  </div>
</template>
<script>
  import FilesOfAgreement from './components/FilesOfAgreement';
  import CarouselAgreementSelector from './components/CarouselAgreementSelector';
  export default {
    components: { CarouselAgreementSelector, FilesOfAgreement },
    props: {
      id: {
        type: String,
        required: true
      }
    }
  }
</script>
